import { render, staticRenderFns } from "./AdvertismentIndex.vue?vue&type=template&id=d557a29a&scoped=true&"
import script from "./AdvertismentIndex.vue?vue&type=script&lang=js&"
export * from "./AdvertismentIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d557a29a",
  null
  
)

export default component.exports